import type { IHeaderRow, Row } from '../table.types';

export const useVisibleTableData = <T,>({
  header,
  rows,
}: {
  header: IHeaderRow<T> | undefined;
  rows: Row[];
}) => {
  const cells = header
    ? header.cells.map(cell =>
        cell.isVisible === undefined ? { ...cell, isVisible: true } : cell,
      )
    : [];

  const visibleColumns = cells.filter(cell => cell.isVisible) ?? [];

  const visibleRows = rows.map(row => ({
    ...row,
    cells: row.cells.filter(
      (_, cellIndex) => cells.at(cellIndex)?.isVisible ?? false,
    ),
  }));

  return {
    visibleColumns,
    visibleRows,
  };
};
